import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

/**
 * This service handles global error handling for the camera application
 */
@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService extends ErrorHandler {
  constructor() {
    super();
  }

  /**
   * Handle application errors globally
   * @param  {Error} error - The error to handle
   */
  handleError(error: Error) {
    try {
      let errorMessage: string = error.message;
      const originalError = this.getOriginalError(error);
      if (originalError !== error) {
        if (originalError instanceof Error || 'message' in originalError)
          errorMessage += '\r\n' + originalError.message;
      }

      if (!environment.production)
        console.error(`handleError:\r\n${errorMessage}`);

      alert(errorMessage);
    } catch (innerError) {
      console.error(innerError);
    }
  }

  /**
   * Get the original error from a wrapped error
   * @param  {any} error - The error to unwrap
   * @returns any
   */
  private getOriginalError(error: any) {
    while (error && error.originalError) {
      error = error.originalError;
    }
    return error;
  }
}
